import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import instance from '@src/api/axiosInstance';

interface AddScheduleSubscribersPayload {
  schedule_id: number;
  subscribers: string[];
}

const addScheduleSubscribers = async (data: AddScheduleSubscribersPayload): Promise<any> => {
  const response = await instance.post('/nexa/schedule/add_subscribers', data);
  return response.data;
};

export const useAddScheduleSubscribers = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addScheduleSubscribers,
    onSuccess: (data) => {
      message.success(data?.message || 'Subscribers added to existing schedule');
      queryClient.invalidateQueries(['nexa-schedule-list']);
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message || 'Failed to add subscribers');
    },
  });
};
